import Vue from "vue";

import CementationActionsCellRenderer from "./components/CementationActionsCellRenderer.vue";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import vSelect from 'vue-select';
import { FormLabel } from "@/app/shared/components";
import CementationSideView from "./components/CementationSideView.vue";
import CementationTypesEnum from "../CementationTypesEnum";

export default {
  components: {
    AgGridVue,
    CementationActionsCellRenderer,
    CementationSideView,
    vSelect,
    FormLabel
  },
  data() {
    return {
      isSidebarActive: false,
      sidebarData: {},

      holes: [],

      selectedCementationStatus: 0,
      cementationTypes: CementationTypesEnum.definition,

      gridApi: null,
      gridOptions: {
        getRowNodeId: (data) => {
          return data.holeId;
        }
      },
      context: { componentParent: this },
      columnDefs: [
        {
          headerName: 'Actions',
          field: 'holeId',
          width: 125,
          editable: false,
          sortable: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          cellRendererFramework: Vue.extend(CementationActionsCellRenderer)
        },
        {
          headerName: this.$t('Status'),
          field: "cementationStatus",
          filter: true,
          width: 165,
          valueGetter: (params) => {
            return CementationTypesEnum.getNameFor(params.data.cementationStatus);
          }
        },
        {
          headerName: this.$t('Drilling.Cementation.HoleName'),
          field: "code",
          filter: true,
          width: 165
        },
        {
          headerName: this.$t('Drilling.Cementation.Drill'),
          field: "latestDrill",
          filter: true
        },
        {
          headerName: this.$t('Drilling.Cementation.Contract'),
          field: "latestContract",
          filter: true
        },
        {
          headerName: this.$t('Drilling.Cementation.DrillingStarted'),
          field: "firstDrillingDate",
          filter: true,
          valueGetter: (params) => {
            return this.$options.filters.toDate(params.data.firstDrillingDate);
          }
        },
        {
          headerName: this.$t('Drilling.Cementation.DrillingEnded'),
          field: "lastDrillingDate",
          filter: true, 
          valueGetter: (params) => {
            return this.$options.filters.toDate(params.data.lastDrillingDate);
          }
        },
        {
          headerName: this.$t('Drilling.Cementation.CementedOn'),
          field: "cementedOn",
          filter: true, 
          valueGetter: (params) => {
            return this.$options.filters.toDate(params.data.cementedOn);
          }
        }
      ],
      components: {
        CementationActionsCellRenderer
      }
    }
  },
  created() {
    this.selectedMainProjectId = Number(this.$store.state.projectId);
  },
  mounted() {
    this.refreshData();
    this.gridApi = this.gridOptions.api;
  },
  watch: {
    selectedCementationStatus() {
      this.gridApi.onFilterChanged();
    }
  },
  methods: {
    doesExternalFilterPass(node) {
      if (node.data === null || node.data === undefined) return false;
      switch (this.selectedCementationStatus) {
      case 0:
        return node.data.cementationStatus === 0;
      case 1:
        return node.data.cementationStatus === 1;
      case 2:
        return node.data.cementationStatus === 2;
      }
      return true;
    },
    edit(data) {
      this.sidebarData = { holes:[data] };
      this.isSidebarActive = true;
    },
    editSelected() {
      const selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length === 0) {
        this.$warn(this.$t('Drilling.Cementation.NoRowsSelected'));
        return;
      }
      if (selectedRows.length === 1) {
        this.edit(selectedRows[0]);
        return;
      }

      this.sidebarData = { holes:selectedRows };
      this.isSidebarActive = true;
    },
    closeSidebar() {
      this.isSidebarActive = false;
    },
    onUpdated(data) {
      this.isSidebarActive = false;
      
      this.gridApi.applyTransaction({ update: [data] });
      this.gridApi.deselectAll();
    },
    async refreshData() {
      this.$vs.loading();
      try {
        const response = await this.$cqrsGet("drilling/cementation/findAll", { params: { projectId: this.selectedMainProjectId } });
        if (!response.data.success) throw new Error(response.data.message);
        this.holes = response.data.model;
      }
      catch (error) {
        this.$notifyError(error);
      }
      finally {
        this.$vs.loading.close();
      }
    }
  }
}